import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Popconfirm, Table, Form, message, Select } from "antd";
import React from "react";
import { RULES } from "Constants/rules";
import { Controller, useFieldArray } from "react-hook-form";
import PartnerSelect from "Components/partner-select";
import { DISPLAY_MODE } from "Constants";

export default function ParentList({
  form,
  mode = DISPLAY_MODE.EDIT,
  ...props
}) {
  const { fields: relations, append, remove } = useFieldArray({
    control: form.control,
    name: "relations",
  });

  const errors = form.errors;
  const watch = form.watch;

  const columns = [
    {
      title: "Velisi",
      dataIndex: ["relations", "relationId"],
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            htmlFor="relationalPartner"
            hasFeedback={true}
            validateStatus={
              errors.relationId &&
              errors.relations[index]?.relationId &&
              "error"
            }
            required={true}
          >
            <PartnerSelect
              form={form}
              objectInValue={false}
              field={`relations[${index}].relationId`}
              defaultValue={relations[index].relationId || null}
              params={{ ruleCode: RULES.RULE0004 }}
              style={{ width: "100%" }}
              readOnly={mode === DISPLAY_MODE.READ_ONLY}
            />
          </Form.Item>
        );
      },
    },

    {
      title: "Yakınlığı",
      dataIndex: "intimacy",
      editable: true,

      render: (text, record, index) => {
        return (
          <Form.Item
            style={{ margin: 0 }}
            hasFeedback={true}
            validateStatus={
              errors.intimacy && errors.relations[index]?.intimacy && "error"
            }
          >
            <Controller
              control={form.control}
              name={`relations[${index}].intimacy`}
              as={
                <Input
                  readOnly={mode === DISPLAY_MODE.READ_ONLY}
                  placeholder="Yakınlığı"
                />
              }
            />
          </Form.Item>
        );
      },
    },
    mode === DISPLAY_MODE.EDIT
      ? {
          title: "İşlemler",
          dataIndex: "operation",
          wrelationIdth: 100,
          fixed: "right",
          render: (text, record, index) => {
            return (
              <Popconfirm
                title="Emin Misin?"
                onConfirm={() => {
                  remove(index);
                }}
                icon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
                okText="Kaldır"
                cancelText="Geri"
              >
                <Button type="danger">
                  <FontAwesomeIcon icon={["far", "trash-alt"]} />
                </Button>
              </Popconfirm>
            );
          },
        }
      : {},
  ];

  return (
    <Table
      size="small"
      scroll={{ x: 300, y: 300 }}
      bordered
      rowKey={(row) => row.relationId}
      title={() => {
        return (
          <Button
            key="add"
            disabled={mode === DISPLAY_MODE.READ_ONLY}
            onClick={() => {
              append({});
            }}
          >
            <FontAwesomeIcon icon={["fas", "plus"]} />
          </Button>
        );
      }}
      dataSource={relations}
      columns={columns}
    />
  );
}
